module.exports = __webpack_public_path__ + "gfx/logoprologin.png";